import { useState, forwardRef, useEffect, useCallback } from "react";
import { Navigate, NavLink, useParams, useNavigate} from 'react-router-dom';
import { useForm, Controller, useFieldArray  } from 'react-hook-form';
import AddressGenerator from '../Caracterizacion/Personas/AdressGenerator';
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import DataTable from 'react-data-table-component';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { ca, es } from 'date-fns/locale';
import SumOneDayDate from "../Utils/SumOneDayDate";
import MenuCaracterizacion from "../Caracterizacion/Componentes/MenuCaracterizacion";
import SeccionPageHeader from "../Utils/SeccionPageHeader";
import CargandoSpinner from "../Utils/CargandoSpinner";
import { FaCalendar } from "react-icons/fa";
import Select from 'react-select';
import { set } from "date-fns";

registerLocale('es', es);
setDefaultLocale('es');

export default function CrearRetorno(){
    const { token, rol, user, sedeActual } = useAuth();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { idRetorno } = useParams();
    const { idCabezaFamilia } = useParams();
    const [entidades, setEntidades] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const [tipoNaturalesas, setTipoNaturalesas] = useState([]);
    const [tiposEntrega, setTiposEntrega] = useState([]);
    const [rubrosProductivos, setRubrosProductivos] = useState([]);
    const [rubrosVivienda, setRubrosVivienda] = useState([]);
    const [rubrosTraslados, setRubrosTraslados] = useState([]);
    const [retornoGuardado, setRetornoGuardado] = useState(false);
    const [tiposExplotacion, setTiposExplotacion] = useState([]);
    const [tiposExplotacionSeleccionados, setTiposExplotacionSeleccionados] = useState([]);
    const [rubrosProductivosSeleccionados, setRubrosProductivosSeleccionados] = useState([]);
    const [rubrosViviendaSeleccionados, setRubrosViviendaSeleccionados] = useState([]);
    const [rubrosTrasladosSeleccionados, setRubrosTrasladosSeleccionados] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    
    const [swalProps, setSwalProps] = useState({});
    const [retorno, setRetorno] = useState({
        id: "0",
        ret_fechaentrevista: "",
        mun_municipio: "",
        dep_departamento: ""
    })
    const [listaIntegrantes, setListaIntegrantes] = useState([]);
    const { control, handleSubmit, register, watch, reset, formState: { errors }} = useForm({
        defaultValues: {
            retornoAcompanamiento: [],
            tiposExplotacionSeleccionados: [],
            rubrosProductivosSeleccionados: [],
            rubrosViviendaSeleccionados: [],
            rubrosTrasladosSeleccionados: [],
            ayudaHumanitaria: '',
            sede: sedeActual
        }
    });
    const retEntregaPrincipal = watch('retEntregaPrincipal');
    const retEntregaOtrasEntidades = watch('retEntregaOtrasEntidades');
    const retSolicitudSeguridad = watch('retSolicitudSeguridad');
    const valorTotal = 
        Number.parseFloat(watch('retValorRecursoPlanProductivo') || 0) + 
        Number.parseFloat(watch('retValorRecursoPlanProductivoCt') || 0) + 
        Number.parseFloat(watch('retValorRecursoTransporte') || 0) + 
        Number.parseFloat(watch('retValorRecursoAcarreo') || 0) + 
        Number.parseFloat(watch('retValorMejoramientoVivienda') || 0) + 
        Number.parseFloat(watch('retValorViviendaNueva') || 0) + 
        Number.parseFloat(watch('retValorSeguridadAlimentaria') || 0) + 
        Number.parseFloat(watch('retValorGastosDeViaje') || 0);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
            <button type="button" className="custom-input" onClick={onClick} onKeyDown={onClick} ref={ref}>
                <input value={value} readOnly className='widthCalendar'/>
                <FaCalendar size={20} color="black" />
            </button>
        ));

    const ActualizarTiposExplotacion = tipoexplotacion => {
        setTiposExplotacionSeleccionados(tipoexplotacion);
    };

    const ActualizarRubrosProductivos = rubroproductivo => {
        setRubrosProductivosSeleccionados(rubroproductivo);
    };
    const ActualizarRubrosVivienda = rubrovivienda => {
        setRubrosViviendaSeleccionados(rubrovivienda);
    };
    const ActualizarRubrosTraslados = rubrotraslado => {
        setRubrosTrasladosSeleccionados(rubrotraslado);
    };

    const [retornoData, setRetornoData] = useState({
        id: "0",
        idpersonaregistro: "",
        ret_fechaentrevista: "",
        mun_municipio: "",
        dep_departamento: "",
        tipo_entorno: "",
        vereda_barrio_peticion: "",
        corregimiento_peticion: "",
        nombre_finca_peticion: "",
        direccion_peticion: "",
        referencias_peticion: "",
        tipo_peticion: "",
        telefono1: "",
        telefono2: "",
        celular: "",
    });

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    
    function ResetFormRetorno (data){
        const fecha = new Date();
        fecha.setHours(fecha.getHours() - 5);
        reset((prevValues) => ({
            ...prevValues,
            id: data?.id || '0',
            idRetorno: data?.idRetorno || idRetorno,
            usrId: user,
            cantidad: data?.cantidad || '1',
            idpersonaregistro: idCabezaFamilia,
            idCabezaFamilia: idCabezaFamilia,
            retRetornoId: data?.idRetorno || '0',
            retIdDetalleAtencion: data?.idRetorno || '0',
            identidad: data?.identidad || '1',
            ayuda: data?.ayuda || '25',
            tipoNaturaleza: data?.tipoNaturaleza || '',
            fecha: data?.fecha || fecha,
            observaciones: data?.observaciones || '',
            retRectraVoluntariedad: data?.retRectraVoluntariedad || '',
            retSolicitudSeguridad: data?.retSolicitudSeguridad || '',
            retConceptoSeguridad: data?.retConceptoSeguridad || '',
            retVisitaDomiciliaria: data?.retVisitaDomiciliaria || '',
            retTalleresPsicosociales: data?.retTalleresPsicosociales || '',
            retTalleresOcupacionales: data?.retTalleresOcupacionales || '',
            retEntregaPrincipal: data?.retEntregaPrincipal || '',
            retEntregaSecundaria: data?.retEntregaSecundaria || '',
            retValorRecursoPlanProductivo: data?.retValorRecursoPlanProductivo || '0',
            retValorRecursoPlanProductivoCt: data?.retValorRecursoPlanProductivoCt || '0',
            retValorRecursoTransporte: data?.retValorRecursoTransporte || '0',
            retValorRecursoAcarreo: data?.retValorRecursoAcarreo || '0',
            retValorMejoramientoVivienda: data?.retValorMejoramientoVivienda || '0',
            retValorViviendaNueva: data?.retValorViviendaNueva || '0',
            retValorSeguridadAlimentaria: data?.retValorSeguridadAlimentaria || '0',
            retValorGastosDeViaje: data?.retValorGastosDeViaje || '0',
            retValorTotal: data?.retValorTotal || '0',
            retEntregaDonaciones: data?.retEntregaDonaciones || 0,
            retEntregaOtrasEntidades: data?.retEntregaOtrasEntidades || 0,
            retCualOtro: data?.retCualOtro || '',
            retEntregaKitAlimentos: data?.retEntregaKitAlimentos || 0,
            retEntregaKitCocina: data?.retEntregaKitCocina || 0,
            retEntregaKitAseo: data?.retEntregaKitAseo || 0,
            retEntregaMana: data?.retEntregaMana || 0,
            ayudaHumanitaria: '',
        }));
    }
    const columnsIntegrantes = [
        {
            name: 'Retorna/Editar Datos',
            cell: row => (
            <div >
                <div className="form-group" >
                    <input 
                        type="checkbox" 
                        checked={row.seleccion || false} 
                        onChange={(e) => {
                            const updatedPersonas = listaIntegrantes.map(persona => 
                                persona.per_idpersona === row.per_idpersona 
                                    ? { ...persona, seleccion: e.target.checked } 
                                    : persona
                            );
                            setListaIntegrantes(updatedPersonas);
                        }} 
                    />
                </div>
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { 
            name: 'Nombres completos', 
            selector: row => `${row.nombre1} ${row.nombre2 || ''} ${row.apellido1} ${row.apellido2 || ''}`.trim(), 
            sortable: true, 
            width:'20%' 
        },
        { name: 'Identificación', selector: row => row.idpersona, sortable: true, width: '10%'},
        { name: 'F.Nacimiento', selector: row => row.fecha_nacimiento, sortable: true, width: '10%' },
        { name: 'Parentesto', selector: row => row.parentesco, sortable: true, width: '10%' },
        { name: 'Etnia', selector: row => row.etnia, sortable: true, width: '10%' },
        { name: 'Edad', selector: row => row.edad, sortable: true, width: '7%' },
        { name: 'Ocupacion actual', selector: row => row.ocupacion, sortable: true, width: '10%' },
        { name: 'Perfil ocupacional', selector: row => row.oficio, sortable: true, width: '10%' },
        { name: 'Estudia actualmente', selector: row => row.tipo_estudio, sortable: true, width: '10%' },
        { name: 'Discapacidad', selector: row => row.discapacidad, sortable: true, width: '10%' },
    ];
    useEffect(() => {
        const fetchData = async () => {
            const url = '/retorno/crearformularioinicializarretornosefectivo';
            const obj = {idRetorno: idRetorno, usrId: user, idCabezaFamilia: idCabezaFamilia};
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamiliadato[0]);
                setRetorno(result.ListaRetornos[0])
                setListaIntegrantes(result.listaIntegrantes);
                setIntegrantes(result.IntegrantesDtos || []);
                setEntidades(result.entidades);
                setAyudas(result.ayudaRetorno);
                setTipoNaturalesas(result.tiposNaturaleza);
                setTiposEntrega(result.tiposEntregaRetorno);
                setTiposExplotacion(result.tiposExplotacion.map(option => ({value: option.id, label: option.tipo_explotacion})));
                setRubrosProductivos(result.tiposEntregaRetorno.filter(option => option.tip_retornotipoexplotacionid === '5').map(option => ({value: option.id, label: option.tip_tipoentrega})));
                setRubrosVivienda(result.tiposEntregaRetorno.filter(option => option.tip_retornotipoexplotacionid === '6').map(option => ({value: option.id, label: option.tip_tipoentrega})));
                setRubrosTraslados(result.tiposEntregaRetorno.filter(option => option.tip_retornotipoexplotacionid === '8').map(option => ({value: option.id, label: option.tip_tipoentrega})));
                setRetornoData({
                    id: result.ListaRetornos[0]?.id || "",
                    ret_fechaentrevista: result.ListaRetornos[0]?.ret_fechaentrevista?.substring(0, 10) || "",
                    dep_departamento: result.ListaRetornos[0]?.dep_departamento || "",
                    mun_municipio: result.ListaRetornos[0]?.mun_municipio || "",
                    tipo_entorno: result.ListaRetornos[0]?.tipo_entorno || "",
                    vereda_barrio_peticion: result.ListaRetornos[0]?.ret_veredabarriopeticion || "",
                    corregimiento_peticion: result.ListaRetornos[0]?.ret_corregimientopeticion || "",
                    nombre_finca_peticion: result.ListaRetornos[0]?.ret_nombrefincapeticion || "",
                    direccion_peticion: result.ListaRetornos[0]?.ret_direccionpeticion || "",
                    referencias_peticion: result.ListaRetornos[0]?.ret_referenciaspeticion || "",
                    tipo_peticion: result.ListaRetornos[0]?.ret_tipopeticion || "",
                    telefono1: result.cabezafamiliadato[0]?.cab_telefono1 || "",
                    telefono2: result.cabezafamiliadato[0]?.cab_telefono2 || "",
                    celular: result.cabezafamiliadato[0]?.cab_celular || "",
                    idpersonaregistro: result.cabezafamiliadato[0]?.cab_idcabezafamilia || ""
                });
                ResetFormRetorno();
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, [idRetorno, token, idCabezaFamilia, user]);
    const guardarRetornoEfectivo = async (data) => {
        debugger;
        if (!tiposExplotacionSeleccionados || tiposExplotacionSeleccionados.length === 0) {
            Mensaje('Validación', 'Debe seleccionar al menos una opción en "Entregas realizadas".');
            setCargando(false);
            return;
        }
        const tiposExplotacionProductivo = tiposExplotacionSeleccionados.some(option => option.value === '5');
        if (tiposExplotacionProductivo && (!rubrosProductivosSeleccionados || rubrosProductivosSeleccionados.length === 0)) {
            Mensaje('Validación', 'Debe seleccionar al menos una opción en "Unidad productiva" cuando "Entregas realizadas" incluye "Unidad Productiva".');
            setCargando(false);
            return;
        }
        const tiposExplotacionVivienda = tiposExplotacionSeleccionados.some(option => option.value === '6');
        if (tiposExplotacionVivienda && (!rubrosViviendaSeleccionados || rubrosViviendaSeleccionados.length === 0)) {
            Mensaje('Validación', 'Debe seleccionar al menos una opción en "Mejoramiento de vivienda" cuando "Entregas realizadas" incluye "Mejoramiento de vivienda".');
            setCargando(false);
            return;
        }
        const tiposExplotacionTraslado = tiposExplotacionSeleccionados.some(option => option.value === '8');
        if (tiposExplotacionTraslado && (!rubrosTrasladosSeleccionados || rubrosTrasladosSeleccionados.length === 0)) {
            Mensaje('Validación', 'Debe seleccionar al menos una opción en "Mudanza y traslado familiar" cuando "Entregas realizadas" incluye "Mudanza y traslado familiar".');
            setCargando(false);
            return;
        }
        const tiposExplotacionAyudaHumanitaria = tiposExplotacionSeleccionados.some(option => option.value === '7');
        if (tiposExplotacionAyudaHumanitaria && (!data.ayudaHumanitaria || data.ayudaHumanitaria.trim() === '')) {
            Mensaje('Validación', 'Debe ingresar el campo "Ayuda humanitaria" cuando "Entregas realizadas" incluye "Ayuda humanitaria".');
            setCargando(false);
            return;
        }
        setCargando(true);
        data.retornoAcompanamiento = listaIntegrantes.filter(persona => persona.seleccion === true)
        data.tiposExplotacionSeleccionados = tiposExplotacionSeleccionados.map(option => ({id: option.value, value: option.label}));
        data.rubrosProductivosSeleccionados = rubrosProductivosSeleccionados.map(option => ({id: option.value, value: option.label}));
        data.rubrosViviendaSeleccionados = rubrosViviendaSeleccionados.map(option => ({id: option.value, value: option.label}));
        data.rubrosTrasladosSeleccionados = rubrosTrasladosSeleccionados.map(option => ({id: option.value, value: option.label}));
        data.retValorTotal = valorTotal.toString();
        data.fecha = data.fecha instanceof Date
            ? data.fecha.toISOString().split('T')[0]
            : (data.fecha ? new Date(data.fecha).toISOString().split('T')[0] : null);
        data.sede = sedeActual;
        const url = '/retorno/guardarretornoefectivo';
        debugger;
        await apiService.post(url, data, token)
        .then(response => {
            if(response.status === 200){
                Mensaje('Guardar retorno efectivo', JSON.stringify(response.data.message));
                setRetornoGuardado(true);
            }
        })
        .catch(error => {
            if(error.status === 422){
                Mensaje('Hubo problemas guardando retorno efectivo', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Hubo problemas guardando retorno efectivo', JSON.stringify(error.response.data));
            }else{
                Mensaje('Hubo problemas guardando retorno efectivo', JSON.stringify(error));
            }
        })
        .finally(() => {setCargando(false);})
    };
    
    

    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Retornos" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Retorno efectivo" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <form className="form-horizontal" onSubmit={handleSubmit(guardarRetornoEfectivo)}>
                                    <div className="card-header text-center">
                                        <h3>COMPONENTE DE RETORNO Y REUBICACION<br />
                                            CARACTERIZACION FAMILIAR Y VISITA DOMICILIARIA
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12 text-center">
                                                <h3 style={{ textAlign: 'center' }}>Tenga en cuenta que una vez hecho efectivo el retorno, los datos de la caracterizaci&oacute;n del mismo no podr&aacute;n ser editados</h3>
                                            </div>
                                        </div>
                                        <input hidden {...register('usrId', { required: true })} />
                                        <input hidden {...register('idRetorno', { required: true })} />
                                        <div className="row">
                                            <div className="col-md-6"><strong>NOMBRE COMPLETO DE LA PERSONA QUE RECIBE : </strong>
                                                <div className="form-group" >
                                                    <select id='idpersonaregistro' {...register('idpersonaregistro', { required: true })} className='form-control' >
                                                        <option value="">Seleccionar</option>
                                                        {integrantes.map((option) => (
                                                        <option key={option.per_idpersona} value={option.per_idpersona}>
                                                            {option.par_parentesco} {option.per_idpersona} {option.nombre}
                                                        </option>
                                                        ))}
                                                    </select>
                                                    {errors.idpersonaregistro && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <strong>Fecha de caracterizaci&oacute;n: </strong>
                                                <span>{retornoData.ret_fechaentrevista}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Departamento: </strong>
                                                <span>{retornoData.dep_departamento}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Municipio: </strong>
                                                <span>{retornoData.mun_municipio}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Entorno urbano o rural: </strong>
                                                <span>{retornoData.tipo_entorno}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Vereda: </strong>
                                                <span>{retornoData.vereda_barrio_peticion}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Corregimiento: </strong>
                                                <span>{retornoData.corregimiento_peticion}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Nombre de la finca: </strong>
                                                <span>{retornoData.nombre_finca_peticion}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Direcci&oacute;n: </strong>
                                                <span>{retornoData.direccion_peticion}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Referencias del lugar y/o indicaciones de llegada: </strong>
                                                <span>{retornoData.referencias_peticion}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Tel&eacute;fonos/Fijos: </strong>
                                                <span>{retornoData.telefono1} - {retornoData.telefono2}</span>
                                            </div>
                                            <div className="col-md-6">
                                                <strong>Celular: </strong>
                                                <span>{retornoData.celular}</span>
                                            </div>
                                        </div>                                        
                                        <input hidden {...register('retRetornoId', { required: true })} />
                                        <input hidden {...register('retIdDetalleAtencion', { required: true })} />
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h1 style={{ textAlign: 'center' }}>Registrar retorno efectivo</h1>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h2 style={{ textAlign: 'center' }}>El acompañamiento realizado correspondi&oacute; a</h2>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card-body table-responsive p-0">
                                                    <DataTable
                                                        title="Integrantes de la familia"
                                                        columns={columnsIntegrantes}
                                                        data={listaIntegrantes}
                                                        progressPending={Cargando}
                                                        pagination
                                                        noDataComponent="No hay datos para mostrar"
                                                    /> 
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label htmlFor="cantidad">Cantidad</label>
                                                <input type="number" className="form-control" id="cantidad" {...register('cantidad', { required: true })} />
                                                {errors.cantidad && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="identidad">Entidades</label>
                                                <select className="form-control" id="identidad" {...register('identidad', { required: true })}>
                                                    {entidades.map((entidad) => (
                                                        <option key={entidad.id} value={entidad.id}>{entidad.ent_entidad}</option>
                                                    ))}
                                                </select>
                                                {errors.identidad && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="ayuda">Ayuda</label>
                                                <select className="form-control" id="ayuda" {...register('ayuda', { required: true })}>
                                                    <option value="">Seleccione una ayuda</option>
                                                    {ayudas.map((ayuda) => (
                                                        <option key={ayuda.id} value={ayuda.id}>{ayuda.ayu_ayuda}</option>
                                                    ))}
                                                </select>
                                                {errors.ayuda && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="tipoNaturaleza">Tipo de Naturaleza</label>
                                                <select className="form-control" id="tipoNaturaleza" {...register('tipoNaturaleza', { required: true })}>
                                                    <option value="">Seleccione un tipo de naturaleza</option>
                                                    {tipoNaturalesas.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>{tipo.tip_tiponaturaleza}</option>
                                                    ))}
                                                </select>
                                                {errors.tipoNaturaleza && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="fecha">Fecha:</label>
                                                    <Controller
                                                        id="fecha"
                                                        control={control}
                                                        name="fecha"
                                                        rules={{ required: true }}
                                                        render={({ field }) => (
                                                            <DatePicker
                                                                selected={field.value || new Date()}
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                            />
                                                        )}
                                                    />
                                                    {errors.fecha && <p style={{ color: 'red' }}>Digite fecha</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                                <textarea className="form-control" id="observaciones" rows="2" {...register('observaciones', { required: true })} />
                                                {errors.observaciones && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-12">
                                                <h2 style={{ textAlign: 'center' }}>Actividades Realizadas</h2>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retRectraVoluntariedad">Rectra Voluntariedad</label>
                                                <select className="form-control" id="retRectraVoluntariedad" {...register('retRectraVoluntariedad', { required: true })}>
                                                    <option value="">Seleccione una opci&oacute;n</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.retRectraVoluntariedad && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retSolicitudSeguridad">Solicitud Seguridad</label>
                                                <select className="form-control" id="retSolicitudSeguridad" {...register('retSolicitudSeguridad', { required: true })}>
                                                    <option value="">Seleccione una opci&oacute;n</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.retSolicitudSeguridad && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            {retSolicitudSeguridad === 'SI' && <div className="col-md-6">
                                                <label htmlFor="retConceptoSeguridad">Concepto Seguridad</label>
                                                <input type="text" className="form-control" id="retConceptoSeguridad" {...register('retConceptoSeguridad',{ validate: value => {
                                                        if (retSolicitudSeguridad === 'SI' && !value) {
                                                        return 'Seleccione una opción';
                                                        }
                                                        return true;
                                                    }
                                                    })} />
                                                {errors.retConceptoSeguridad && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>}
                                            <div className="col-md-6">
                                                <label htmlFor="retVisitaDomiciliaria">Visita Domiciliaria</label>
                                                <select className="form-control" id="retVisitaDomiciliaria" {...register('retVisitaDomiciliaria', { required: true })}>
                                                    <option value="">Seleccione una opci&oacute;n</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.retVisitaDomiciliaria && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div hidden className="col-md-6">
                                                <label htmlFor="retTalleresPsicosociales">Talleres Psicosociales</label>
                                                <select className="form-control" id="retTalleresPsicosociales" {...register('retTalleresPsicosociales')}>
                                                    <option value="">Seleccione una opci&oacute;n</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.retTalleresPsicosociales && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div hidden className="col-md-6">
                                                <label htmlFor="retTalleresOcupacionales">Talleres Ocupacionales</label>
                                                <select className="form-control" id="retTalleresOcupacionales" {...register('retTalleresOcupacionales')}>
                                                    <option value="">Seleccione una opci&oacute;n</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.retTalleresOcupacionales && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-12">
                                                <h2 style={{ textAlign: 'center' }}>Entregas Realizadas</h2>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group" >
                                                    <label htmlFor="tipoExplotacion">Entregas realizadas</label>
                                                    <Select
                                                        id="tipoExplotacion"
                                                        value={tiposExplotacionSeleccionados}
                                                        isMulti
                                                        name="tipoExplotacion"
                                                        options={tiposExplotacion}
                                                        onChange={ActualizarTiposExplotacion}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Seleccione"
                                                    />
                                                    {errors.tipoExplotacion && <p style={{color: 'red'}}>Seleccione campos</p>}
                                                </div>
                                            </div>
                                            {tiposExplotacionSeleccionados.filter(e => e.value === '5').length > 0 && (<div className="col-md-6">
                                                <div className="form-group" >
                                                    <label htmlFor="rubrosProductivos">Unidad productiva</label>
                                                    <Select
                                                        id="rubrosProductivos"
                                                        value={rubrosProductivosSeleccionados}
                                                        isMulti
                                                        name="rubrosProductivo"
                                                        options={rubrosProductivos}
                                                        onChange={ActualizarRubrosProductivos}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Seleccione"
                                                    />
                                                    {errors.rubrosProductivo && <p style={{color: 'red'}}>Seleccione campos</p>}
                                                </div>
                                            </div>)}
                                            {tiposExplotacionSeleccionados.filter(e => e.value === '6').length > 0 && (<div className="col-md-6">
                                                <div className="form-group" >
                                                    <label htmlFor="rubrosVivienda">Mejoramiento de vivienda</label>
                                                    <Select
                                                        id="rubrosVivienda"
                                                        value={rubrosViviendaSeleccionados}
                                                        isMulti
                                                        name="rubrosVivienda"
                                                        options={rubrosVivienda}
                                                        onChange={ActualizarRubrosVivienda}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Seleccione"
                                                    />
                                                    {errors.rubrosVivienda && <p style={{color: 'red'}}>Seleccione campos</p>}
                                                </div>
                                            </div>)}
                                            {tiposExplotacionSeleccionados.filter(e => e.value === '8').length > 0 && (<div className="col-md-6">
                                                <div className="form-group" >
                                                    <label htmlFor="rubrosTraslados">Mudanza y traslado familiar</label>
                                                    <Select
                                                        id="rubrosTraslados"
                                                        value={rubrosTrasladosSeleccionados}
                                                        isMulti
                                                        name="rubrosTraslados"
                                                        options={rubrosTraslados}
                                                        onChange={ActualizarRubrosTraslados}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Seleccione"
                                                    />
                                                    {errors.rubrosTraslados && <p style={{color: 'red'}}>Seleccione campos</p>}
                                                </div>
                                            </div>)}
                                            {tiposExplotacionSeleccionados.filter(e => e.value === '7').length > 0 && (<div className="col-md-12">
                                                <label htmlFor="ayudaHumanitaria">Ayuda Humanitaria</label>
                                                <textarea
                                                    className="form-control"
                                                    id="ayudaHumanitaria"
                                                    rows="2"
                                                    maxLength={500}
                                                    {...register('ayudaHumanitaria', {
                                                        required: true,
                                                        maxLength: {
                                                            value: 500,
                                                            message: 'Máximo 500 caracteres'
                                                        }
                                                    })}
                                                    onInput={e => e.target.value = e.target.value.toUpperCase()}
                                                />
                                                {errors.ayudaHumanitaria && (
                                                    <p style={{ color: 'red' }}>{errors.ayudaHumanitaria.message || 'Este campo es obligatorio'}</p>
                                                )}
                                            </div>)}
                                            <div hidden className="col-md-6">
                                                <label htmlFor="retEntregaPrincipal">Entrega Principal</label>
                                                <select className="form-control" id="retEntregaPrincipal" {...register('retEntregaPrincipal')}>
                                                    <option value="">Seleccione una opci&oacute;n</option>
                                                    {tiposEntrega.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>{tipo.tip_tipoentrega}</option>
                                                    ))}
                                                </select>
                                                {errors.retEntregaPrincipal && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            {retEntregaPrincipal !== "" && <div className="col-md-6">
                                                <label htmlFor="retEntregaSecundaria">Entrega Secundaria</label>
                                                <select className="form-control" id="retEntregaSecundaria" {...register('retEntregaSecundaria')}>
                                                    <option value="">Seleccione una opci&oacute;n</option>
                                                    {tiposEntrega.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>{tipo.tip_tipoentrega}</option>
                                                    ))}
                                                </select>
                                                {errors.retEntregaSecundaria && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label htmlFor="retValorRecursoPlanProductivo">Valor Recurso Plan Productivo</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorRecursoPlanProductivo" 
                                                    onBlur={(e => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    })}
                                                    {...register('retValorRecursoPlanProductivo', { required: true })} 
                                                    />
                                                {errors.retValorRecursoPlanProductivo && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorRecursoPlanProductivoCt">Valor Recurso Plan Productivo CT</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorRecursoPlanProductivoCt" 
                                                    onBlur={(e => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    })}
                                                    {...register('retValorRecursoPlanProductivoCt', { required: true })} />
                                                {errors.retValorRecursoPlanProductivoCt && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorRecursoTransporte">Valor Recurso Transporte</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorRecursoTransporte" 
                                                    onBlur={(e => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    })}
                                                    {...register('retValorRecursoTransporte', { required: true })} />
                                                {errors.retValorRecursoTransporte && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorRecursoAcarreo">Valor Recurso Acarreo</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorRecursoAcarreo" 
                                                    onBlur={(e => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    })}
                                                    {...register('retValorRecursoAcarreo', { required: true })} />
                                                {errors.retValorRecursoAcarreo && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorMejoramientoVivienda">Valor Mejoramiento Vivienda</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorMejoramientoVivienda" 
                                                    onBlur={(e => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    })}
                                                    {...register('retValorMejoramientoVivienda', { required: true })} />
                                                {errors.retValorMejoramientoVivienda && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorViviendaNueva">Valor Vivienda Nueva</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorViviendaNueva" 
                                                    {...register('retValorViviendaNueva', { required: true })} />
                                                {errors.retValorViviendaNueva && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorSeguridadAlimentaria">Valor Seguridad Alimentaria</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorSeguridadAlimentaria" 
                                                    onBlur={(e => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    })}
                                                    {...register('retValorSeguridadAlimentaria', { required: true })} />
                                                {errors.retValorSeguridadAlimentaria && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorGastosDeViaje">Valor Gastos De Viaje</label>
                                                <input type="number" 
                                                    className="form-control" 
                                                    id="retValorGastosDeViaje" 
                                                    onBlur={(e => {
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    })}
                                                    {...register('retValorGastosDeViaje', { required: true })} />
                                                {errors.retValorGastosDeViaje && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retValorTotal">TOTAL ENTREGAS EN ACOMPAÑANIMENTO</label>
                                                <input disabled type="number" className="form-control" id="retValorTotal" value={valorTotal} {...register('retValorTotal', { required: true })} />
                                                {errors.retValorTotal && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-12">
                                                <h2 style={{ textAlign: 'center' }}>Otras Entregas (Instituciones en ejercicio de coordinaci&oacute;n y articulaci&oacute;n) DAPARD</h2>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retEntregaDonaciones">Entrega Donaciones</label>
                                                <select className="form-control" id="retEntregaDonaciones" {...register('retEntregaDonaciones', { required: true })}>
                                                    <option value={1}>SI</option>
                                                    <option value={0}>NO</option>
                                                </select>
                                                {errors.retEntregaDonaciones && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="retEntregaOtrasEntidades">Entrega Otras Entidades</label>
                                                <select className="form-control" id="retEntregaOtrasEntidades" {...register('retEntregaOtrasEntidades', { required: true })}>
                                                    <option value={1}>SI</option>
                                                    <option value={0}>NO</option>
                                                </select>
                                                {errors.retEntregaOtrasEntidades && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                            {retEntregaOtrasEntidades === '1' && <div className="col-md-6">
                                                <label htmlFor="retCualOtro">Cual Otro</label>
                                                <input type="text" className="form-control" id="retCualOtro" {...register('retCualOtro', { validate: value => {
                                                        if (retEntregaOtrasEntidades === 1 && !value) {
                                                        return 'Seleccione una opción';
                                                        }
                                                        return true;
                                                    }
                                                    })} />
                                                {errors.retCualOtro && <p style={{ color: 'red' }}>{errors.retCualOtro.message}</p>}
                                            </div>}
                                            <div hidden className="col-md-6">
                                                <label htmlFor="retEntregaKitAlimentos">Entrega Kit Alimentos</label>
                                                <input type="number" className="form-control" id="retEntregaKitAlimentos" {...register('retEntregaKitAlimentos')} />
                                            </div>
                                            <div hidden className="col-md-6">
                                                <label htmlFor="retEntregaKitCocina">Entrega Kit Cocina</label>
                                                <input type="number" className="form-control" id="retEntregaKitCocina" {...register('retEntregaKitCocina')} />
                                            </div>
                                            <div hidden className="col-md-6">
                                                <label htmlFor="retEntregaKitAseo">Entrega Kit Aseo</label>
                                                <input type="number" className="form-control" id="retEntregaKitAseo" {...register('retEntregaKitAseo')} />
                                            </div>
                                            <div hidden className="col-md-6">
                                                <label htmlFor="retEntregaMana">Entrega Mana</label>
                                                <input type="number" className="form-control" id="retEntregaMana" {...register('retEntregaMana')} />
                                            </div>
                                            
                                        </div>

                                    </div>
                                    {!retornoGuardado && <div className="card-footer">
                                        <button type="submit" className="btn btn-info">Guardar</button>
                                    </div>}
                                    {retornoGuardado && <div className="card-footer">
                                        <button type="button" className="btn btn-info" onClick={() => {
                                            navigate(`/retornos/retorno/${idCabezaFamilia}`);
                                        }}>Volver</button>
                                    </div>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps}
                    didClose={() => {
                        setSwalProps({})
                    }} />
                <Tooltip id="tooltiparriba" place="right" />
            </section>
        </div>
    );
}